/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';

import _get from 'lodash/get';

import MovieProfile from './Types/Movie/movie-profile';
import ChannelProfile from './Types/Channel/channel-profile';
import EpgEventProfile from './Types/EpgEvent/epg-event-profile';
import NpvrProfile from './Types/Npvr/npvr-profile';
import NotificationProfile from './Types/Notification/notification-profile';
import TvSeries from './Types/TvSeries/tv-series-profile';
import Package from './Types/Package/package-profile';
import Subscription from './Types/Subscription/subscription-profile';

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  _renderProfile() {

    switch (true) {
      case _get(this.props, 'entity.type') === 'movie':
        return (<MovieProfile movieId={_get(this.props.entity, 'id')} onClose={this.props.onClose} />);

      case _get(this.props, 'entity.type') === 'channel':
        return (<ChannelProfile channelId={_get(this.props.entity, 'id')} onClose={this.props.onClose} />);

      case _get(this.props, 'entity.type') === 'epg_event':
        return (<EpgEventProfile eventId={_get(this.props.entity, 'id')} channel={this.props.channel} forceLive={_get(this.props.entity, '_forceLive', false)} onClose={this.props.onClose} />);

      case _get(this.props, 'entity.type') === 'npvr':
        return (<NpvrProfile npvrId={_get(this.props.entity, 'id')} onClose={this.props.onClose} />);

      case _get(this.props, 'entity.type') === 'notification':
        return (<NotificationProfile notificationId={_get(this.props.entity, 'id')} onClose={this.props.onClose} />);

      case _get(this.props, 'entity.type') === 'package' && (_get(this.props, 'entity.package_type') === 'tv_series' || _get(this.props, 'entity.opt') === 'tv_series'):
        return (<TvSeries
          tvSeriesId={_get(this.props.entity, 'id')}
          onClose={this.props.onClose}
          initSeason={this.props.season}
          initEpisode={this.props.episode}
        />);

      case _get(this.props, 'entity.type') === 'package' && (_get(this.props, 'entity.package_type') === 'generic' || _get(this.props, 'entity.opt') === 'generic'):
        return (<Package pckageId={_get(this.props.entity, 'id')} onClose={this.props.onClose} />);

      case _get(this.props, 'entity.type') === 'subscription':
        return (<Subscription subscriptionId={_get(this.props.entity, 'id')} onClose={this.props.onClose} />);

      default:

        return (
          <div className="profile movie-inf-example movie-inf-profile bg-black radius"></div>
        );
    }
  }

  render() {

    return (
      <div className="showcase-expanded-profile" id="showcase_expanded_tile">
        {this._renderProfile()}
      </div>
    );
  }
}

Profile.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string
  })
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/index.js